var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-transition-fade m-login-callback"},[_c('AtomLoadingPrimary')],1)}
var staticRenderFns = []

export { render, staticRenderFns }